module.exports = __webpack_public_path__ + "cart-empty.png?80e377d70b9b091c20904b365a0ed7b7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/cart/cart-empty.png
// module id = 33
// module chunks = 0